/* @flow */

import * as React from 'react';
import classNames from 'classnames';

// Styles
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './Branding.style';

import dateMessages from 'src/shared/app/base/date/l10n/dateL10n';

// Hooks
import { useIntl } from 'react-intl';

// Utils
import { defaultBraindateSingular } from '@braindate/domain/lib/event/setting';
import { getEventBraindateSingular } from '@braindate/domain/lib/event/util';
import useEvent from 'src/shared/domain/event/hook/useEvent';

import EventBranding from 'src/shared/app/nav/component/branding/event/EventBranding';

const useStyles = createUseThemeStyles(styles);

type Props = {
  layoutClass?: string,
};

const Branding = ({ layoutClass }: Props): React.Node => {
  const classes = useStyles();
  const event = useEvent();

  const intl = useIntl();

  const braindateWord =
    getEventBraindateSingular(event, intl.locale) || defaultBraindateSingular;

  return (
    <div className={classNames(classes.root, layoutClass)}>
      <span className={classes.eventName}>
        <span className={classes.braindate}>{braindateWord}</span>
        <sup>TM</sup> <i>{intl.formatMessage(dateMessages.at)}</i>
      </span>

      <div className={classes.logo}>
        <EventBranding />
      </div>
    </div>
  );
};

export default Branding;
